import { ActionTree, MutationTree } from 'vuex';
import { RootState } from '@/interfaces/stores/RootState';
import { DepositRule } from '@/interfaces/models/DepositRule';
import Filter from '@/interfaces/api/Filter';
import DepositRuleApiService from '@/api/http/DepositRuleApiService';
import { Pagination } from '@/interfaces/api/Pagination';
import { Page } from '@/interfaces/api/Page';
import { AxiosResponse } from 'axios';

interface DepositRuleState {
  active: DepositRule | null;
  items: DepositRule[];
  filter: Filter;
  pagination: {
    total: number;
  };
}

const state: DepositRuleState = {
  active: null,
  items: [],
  filter: {},
  pagination: {
    total: 0,
  },
};

const api: DepositRuleApiService = new DepositRuleApiService();

const actions: ActionTree<DepositRuleState, RootState> = {
  fetch({ commit, state }, page: Page) {
    return api.fetch(page, state.filter).then((res: AxiosResponse<Pagination<DepositRule | DepositRule[]>>) => {
      commit('setItems', res.data);
    });
  },
  store({ commit }, data: Partial<DepositRule>) {
    return api.store(data).then((res: AxiosResponse<DepositRule>) => {
      commit('addItem', res.data);
    });
  },
  show({ commit }, data: { id: string }) {
    return api.show(data).then((res: AxiosResponse<DepositRule>) => {
      commit('setActive', res.data);
    });
  },
  update({ commit }, data: Partial<DepositRule>) {
    return api.update(data).then((res: AxiosResponse<DepositRule>) => {
      commit('update', res.data);
    });
  },
  destroy({ commit }, data: { id: string }) {
    return api.delete(data).then(() => {
      commit('removeItem', { _id: data.id });
    });
  },
  setFilter({ commit }, filter: Filter) {
    commit('setFilter', filter);
  },
};
const mutations: MutationTree<DepositRuleState> = {
  setItems(state: DepositRuleState, data: Pagination<DepositRule>) {
    state.items = (data.data as DepositRule[]) || data;
    state.pagination.total = data?.total || 0;
  },
  setFilter(state: DepositRuleState, filter: Filter) {
    state.filter = filter;
  },
  addItem(state: DepositRuleState, data: DepositRule) {
    state!.items.push(data);
  },
  update(state: DepositRuleState, data: DepositRule) {
    state.items = [...(state.items as DepositRule[]).filter((item: DepositRule) => item._id !== data._id), data];
  },
  setActive(state: DepositRuleState, data: DepositRule) {
    state.active = data;
  },
  removeItem(state: DepositRuleState, data: { _id: string }) {
    state.items = state.items.filter((item: DepositRule) => item._id !== data._id);
  },
};

export default {
  state,
  actions,
  mutations,
  namespaced: true,
};
